<div class="itdr-empty d-flex justify-content-center py-5">
  <div class="itdr-empty__card card shadow-sm text-center py-4 px-5">
    <div class="itdr-empty__icon mb-3">
      <div
        class="spinner-border text-primary"
        role="status"
      >
        <span class="visually-hidden">Initial sync in progress</span>
      </div>
    </div>
    <h5 class="mb-2">Hang tight, your dashboard is brewing</h5>
    <p class="text-muted mb-2">
      Your required integrations are connected and we're working through gathering your data for the first time.
    </p>
    <p class="text-muted small mb-0">
      Initial syncs usually wrap up in a few hours, though it can take up to 24 hours. Feel free to grab some more
      coffee and check back in a while!
    </p>
  </div>
</div>
